module.exports = __webpack_public_path__ + "media/78.a5f1975a.wav";